import { ActionTypes } from './constants';

export const updateUser = payload => ({
    type: ActionTypes.UPDATE_USER,
    payload,
});
